import React from 'react';
import { Data } from '../../types/data-providers';
import { useData, dataFromDataset } from './DataProviderCache';

import * as OrgManager from '../domain/org-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';

import { PromiseType } from '../../types';

export type DeviceData = PromiseType<ReturnType<typeof OrgManager.getOrganizationType>>;
type ContextState = Data<DeviceData>;
const Context = React.createContext<ContextState | null>(null);

function useGetOrganizationCheckDetails(): ContextState {
    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useGetOrganizationCheckDetails must be used within a GetOrganizationCheckDetails');
    }
    return contextState;
}

const GetOrgCheckProvider: React.FC<{ organizationId: string }> = (props) => {
    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'get-org-type-details',
        id: props.organizationId,
        dataFn: React.useCallback(() => OrgManager.getOrganizationType(authHelper, props.organizationId), [
            authHelper,
            props.organizationId,
        ]),
    });

    const getOrgTypeData = dataFromDataset(dataset);

    return <Context.Provider value={getOrgTypeData}>{props.children}</Context.Provider>;
};

const TestOrgCheckProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { GetOrgCheckProvider, TestOrgCheckProvider, useGetOrganizationCheckDetails };
